// extracted by mini-css-extract-plugin
module.exports =  {"tag":"_7a3fb80146--tag--Gj4bC","tag_content":"_7a3fb80146--tag_content--EpMVE","tag_close":"_7a3fb80146--tag_close--NT5sL"};